<template>

<div 
  v-if="isInEditorMode"
  :class="[{'dr-grid-snippet-editor-mode dr-snippet-container': isInEditorMode, 'dr-grid-layout-column-selected' : isSelected}]"
  @click.stop="selectComponent(model)"
  @contextmenu="onShowContextMenu">
  
    <div v-if="isInEditorMode" class="dr-snippet-overlay">
    </div>
    <portal to="action-buttons" v-if="isSelected">
      <v-tooltip bottom>
          <template v-slot:activator="{ on }">
          <v-btn v-on="on" text color="error" @click="onDeleteSnippet">
              <font-awesome-icon :icon="['fal', 'trash-alt']" size="lg"/>
          </v-btn>
          </template>
          <span>{{ $t("vuetifyWidgets.common.remove") }}</span>
      </v-tooltip>
    </portal>

    <component
        v-if="snippet"
        :key="snippet.Model.$ID"
        :is="snippet.Model.$Type"
        :model="snippet.Model"
    />
    <div v-else></div>

    <!-- Контекстное меню -->
    <widgets-context-menu 
      v-if="isInEditorMode"
      v-model="showContextMenu" 
      :x="x" 
      :y="y"
      :snippetCreatable="false"
      :widgetModel="model"
      @deleteComponent="onDeleteComponentFromContextMenu"
      @pasteCopiedWidget="onPasteCopiedWidget"
    />
</div>
<component
  v-else-if="snippet && isVisible"
  :key="snippet.Model.$ID"
  :is="snippet.Model.$Type"
  :model="snippet.Model"
  :dataSource="getDataSource"
  :parentDataWidget="parentDataWidget"
  @callDataSourceAction="$emit('callDataSourceAction', $event)"
/>
</template>

<script>
import mixin from '../../mixins/base-mixin'
import contextMenuMixin from '../../mixins/contextmenu-mixin'
import inputMixin from '../../mixins/input-mixin'

export default {
  mixins: [mixin, contextMenuMixin, inputMixin],
  computed: {
    snippet() {
      return this.$store.state[this.stateName].snippets.find(x => (x.$ID || x.Name) === this.model.CurrentTemplate)
    },
    getDataSource() {
      if (this.model && this.model.AdditionalProperties) {
        return {...this.dataSource, ...this.model.AdditionalProperties}
      }
      return this.dataSource
    }
  },
  methods: {
    onDeleteSnippet() {
      this.$emit('deleteComponent', this.model)
    }
  }
}
</script>

<style>
.dr-snippet-container {
  border: 1px solid #D3D3D3;
  margin: 5px;
  padding: 5px;
  min-height: 50px;
  position: relative;
}
.dr-snippet-overlay {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  z-index: 2;
  background-color: rgba(0,0,0,0.3);
}
</style>
